// Helpers for reading product variant data on the storefront.
// A product always has a `variants` array after migration. We expose safe
// accessors so UI code never has to defend against missing fields.

export function activeVariants(product) {
  if (!product) return [];
  const list = Array.isArray(product.variants) ? product.variants : [];
  return list
    .filter((v) => v && v.active !== false)
    .slice()
    .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
}

export function defaultVariant(product) {
  const list = activeVariants(product);
  if (list.length === 0) return null;
  return list.find((v) => v.default) || list[0];
}

export function findVariant(product, variantId) {
  const list = activeVariants(product);
  return list.find((v) => v.id === variantId) || defaultVariant(product);
}

export function minVariantPrice(product) {
  const list = activeVariants(product);
  if (list.length === 0) return Number(product?.price || 0);
  return Math.min(...list.map((v) => Number(v.price || 0)));
}

export function hasMultipleVariants(product) {
  return activeVariants(product).length > 1;
}
